<template>
  <v-container style="max-width: 100%">
    <v-tabs
      v-model="activeTabPlacements"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab
        v-for="itemTab in itemsTab"
        :key="itemTab"
      >
        <span class="ppc_darkgreen--text">
          {{ itemTab }}
        </span>
      </v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="activeTabPlacements">
      <v-tab-item>
        <span class="d-flex flex-column">
          <v-row justify="center">
            <div class="d-flex flex-row elevation-1 px-2 pt-4 mb-2">
              <v-radio-group
                v-model="scopeResourcesPlanned"
                row
                class="mt-4 d-flex flex-column"
                @change="getResources(), selectedReservation=[]"
              >
                <div class="d-flex flex-row flex-wrap">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-center">
                      <v-radio
                        label="Ongoing"
                        value="ongoing"
                        class="my-0 py-0"
                      />
                    </div>
                    <v-divider class="my-2" />
                    <div class="d-flex flex-row flex-wrap">
                      <div class="d-flex flex-row flex-wrap">
                        <v-radio
                          label="Not Confirmed"
                          value="notConfirmed"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="To be placed"
                          value="notPlaced"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="Placed"
                          value="placed"
                          class="my-0 py-0"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mx-2">
                    <v-radio
                      label="Completed"
                      value="completed"
                      class="my-0 py-0"
                    />
                  </div>
                </div>
              </v-radio-group>
            </div>
          </v-row>
          <v-data-table
            v-model="selectedReservation"
            :headers="headersResourcesScope"
            :items="resourcesScope"
            sort-by="start"
            class="elevation-1"
            :search="searchResourcesScope"
            :footer-props="{
              'items-per-page-options': [itemsPerPage]
            }"
            :show-select="scopeResourcesPlanned === 'notPlaced'"
            :single-select="selectedReservationSingleSelect"
            @input="selectResourceReservation"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchResourcesScope"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ resourcesScope.length }` + ' project placement(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
                <v-spacer />
                <v-btn
                  v-if="scopeResourcesPlanned === 'notPlaced'"
                  :disabled="selectedReservation.length === 0"
                  class="mx-2"
                  @click="goCartaDePresentacion(selectedReservation)"
                >
                  Reservation Request
                </v-btn>
                <v-btn
                  v-if="scopeResourcesPlanned === 'notPlaced'"
                  :disabled="selectedReservation.length === 0"
                  class="mx-2"
                  @click="confirmReservations(selectedReservation)"
                >
                  Confirm Reservations
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    small 
                    rounded 
                    v-bind="attrs"
                    v-on="on" 
                    @click="goClient(item.client_id, item.id)"
                  >
                    {{ item.full_name }}
                  </v-btn>
                </template>
                <span>go to client</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.start`]="{ item }">
              <span v-html="formattedDate(item.start, 'date')" />
            </template>
            <template v-slot:[`item.end`]="{ item }">
              <span v-html="formattedDate(item.end, 'date')" />
            </template>
            <template v-slot:[`item.type_id`]="{ item }">
              <span v-if="item.type_id === 1">Volunteering</span>
              <span v-else>Internship</span>
            </template>
            <template v-slot:[`item.statusResourceId`]="{ item }">
              <v-chip
                :color="getStatusResource(item.statusResourceId).color"
                text-color="white"
                v-html="getStatusResource(item.statusResourceId).name"
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                :disabled="item.updating === true"
                @click="openDialogEditResource(item.id)"
              >
                $vuetify.icons.icon_mdi_pencil
              </v-icon>
            </template>
          </v-data-table>
        </span>

        <v-dialog
          v-model="dialogEditResource"
          max-width="800px"
        >
          <v-card
            v-if="resource"
            class="d-flex flex-row flex-wrap"
            color="blue lighten-2"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue lighten-2"
              style="width: 100%"
            >
              <div>
                <v-card-title>
                  <span
                    v-if="resource.type_id === 1"
                    class=" white--text"
                  >Volunteer Placement #{{ resource.number_type }} - {{ resource.full_name }}</span> 
                  <span
                    v-if="resource.type_id === 2"
                    class=" white--text"
                  >Internship Placement #{{ resource.number_type }} - {{ resource.full_name }}</span>
                </v-card-title>
              </div>
              <v-chip
                :color="getStatusResource(resource.statusResourceId).color"
                text-color="white"
                class="ma-4"
                v-html="getStatusResource(resource.statusResourceId).name"
              />
            </v-card>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 450px"
            >
              <v-card-text>
                <v-select
                  v-model="resource.category_id"
                  :items="categoriesProjects(resource.type_id)"
                  item-text="category"
                  item-value="category_id"
                  :menu-props="{ auto: true }"
                  label="Category"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="blue"
                  :disabled="resource.statusResourceId === 1"
                  @click:clear="resource.project_id = null, resource.placement_id = null"
                  @change="resource.project_id = null, resource.placement_id = null"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.category }}</span>
                  </template>
                </v-select>
                <v-select
                  v-model="resource.project_id"
                  :items="filterProjects(resource.type_id, resource.category_id, resource.project_id)"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Project"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="blue"
                  :disabled="resource.statusResourceId === 1"
                  @click:clear="resource.project_id = null, resource.placement_id = null"
                  @change="resource.placement_id = null, resource.category_id = filterProjects(resource.type_id, 
                                                                                               resource.category_id, resource.project_id)[0].category_id"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.name }}</span>
                  </template>
                </v-select>
                <v-select
                  v-model="resource.placement_id"
                  :items="filterPlacements(resource.type_id, resource.category_id, resource.project_id)"
                  item-text="organisation"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Organisation"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="blue"
                  :disabled="!resource.project_id || resource.statusResourceId === 1"
                  @click:clear="resource.reserved = null"
                  @change="resource.category_id = filterPlacements(resource.type_id, resource.category_id, resource.project_id)[0].category_id, 
                           resource.project_id = filterPlacements(resource.type_id, resource.category_id, resource.project_id)[0].project_id"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.organisation }}</span>
                  </template>
                </v-select>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="from"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resource.start)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resource.statusResourceId === 1"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="resource.start"
                    no-title
                    scrollable
                    color="blue"
                    @change="calcDatesResource('start')"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="until"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resource.end)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resource.statusResourceId === 1"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="resource.end"
                    no-title
                    scrollable
                    color="blue"
                    @change="calcDatesResource('end')"
                  />
                </v-menu>
                <v-slider
                  v-model="resource.duration"
                  step="1"
                  ticks
                  tick-size="4"
                  thumb-label="always"
                  :min="1"
                  :max="36"
                  hint="Duration in weeks"
                  persistent-hint
                  thumb-color="ppc_pink"
                  track-color="ppc_grey"
                  color="white"
                  class="mt-8"
                  :disabled="resource.statusResourceId === 1"
                  @change="calcDatesResource('duration')"
                />
              </v-card-text>
              <v-radio-group
                v-model="resource.projectMorningAfternoon"
                row
                class="mt-4 ml-4 d-flex flex-column"
              >
                <v-radio
                  label="To be confirmed"
                  value="to be confirmed"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Mornings"
                  value="mornings"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Afternoons"
                  value="afternoons"
                  class="my-0 py-0"
                  color="white"
                />
              </v-radio-group>
              <v-textarea
                v-model="resource.comments"
                class="rounded-xl ml-2"
                auto-grow
                clearable
                counter="255"
                outlined
                color="white"
                label="Comments (255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
              />
            </div>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <span
                  class="white--text"
                >
                  Donation: 
                </span>
                <v-btn
                  small
                  width="80"
                  color="blue"
                  class="white--text mx-2"
                  @click="resource.payment = calcDonationProject"
                >
                  ${{ calcDonationProject }}
                </v-btn>
                <span
                  class="white--text"
                >
                  (${{ getDonationProject }}
                </span>
                <span
                  class="white--text"
                >
                  {{ getDonationType }})
                </span>
                <v-text-field
                  v-model="resource.payment"
                  label="Donation payment USD"
                  class="text-input-white"
                  color="white"
                  :disabled="resource.amountPaidReceiver === resource.payment && resource.payment > 0"
                  @change="changePayment()"
                />
                <div
                  v-if="resource.placement_id"
                  class="white--text mb-4"
                >
                  {{ getPlacementComments }}
                </div>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span class="d-flex flex-row">
                      <v-text-field
                        label="Info to placement"
                        v-bind="attrs"
                        prepend-icon="$vuetify.icons.icon_mdi_calendar"
                        :value="formattedDate(resource.info_to_provider)"
                        clearable
                        readonly
                        class="text-input-white"
                        color="white"
                        :disabled="resource.statusResourceId === 1"
                        v-on="on"
                        @click:clear="resource.info_to_provider = null"
                      />
                    </span>
                  </template>
                  <v-date-picker
                    v-model="resource.info_to_provider"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Reserved"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resource.reserved)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resource.statusResourceId === 1"
                      v-on="on"
                      @click:clear="resource.reserved = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resource.reserved"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Info to client"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resource.info_to_client)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resource.statusResourceId === 1"
                      v-on="on"
                      @click:clear="resource.info_to_client = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resource.info_to_client"
                    no-title
                    scrollable
                    color="blue"
                    @change="checkResourceDates()"
                  />
                </v-menu>
              </v-card-text>
            </div>
            <v-card-actions
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue lighten-2"
              style="width: 100%"
            >
              <div class="caption blacck--text">
                service - resource nr: {{ resource.service_id }} - {{ resource.id }}
              </div>
              <v-spacer />
              <v-btn
                v-if="resource.transaction_id"
                color="blue lighten-3"
                class="ma-4"
                @click="openTransactionOutgoings(resource.transaction_id)"
              >
                <v-icon color="white">
                  $vuetify.icons.icon_mdi_credit_card
                </v-icon>
                <span class="white--text">Open Transaction</span>
              </v-btn>
              <v-spacer />
              <v-btn
                color="white"
                text
                @click="dialogEditResource = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="white"
                text
                @click="dialogEditResource = false, $store.dispatch('setLoadingApp', 1), insertUpdateResource()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>
            Projects to be Paid
            <span v-if="hasDonationsToBePaid">
              (${{ donationsToBePaidFormatted }})
            </span>
          </v-toolbar-title>
        </v-toolbar>
        <v-tabs
          v-model="activeTabDonations"
          background-color="transparent"
          color="basil"
          grow
        >
          <v-tab
            v-for="itemTab in itemsDonationsTab"
            :key="itemTab"
          >
            <span class="ppc_darkgreen--text">
              {{ itemTab }}
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTabDonations">
          <v-tab-item>
            <v-data-table
              v-if="resourcesToBePaid.length > 0"
              :headers="headersResourcesDonations"
              :items="resourcesToBePaid"
              sort-by="start"
              class="elevation-1"
              group-by="organisationName"
              disable-sort
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`group.header`]="{items}">
                <th colspan="7">
                  <div class="d-flex flex-row ma-4">
                    <h3>{{ items[0].organisationName }} ${{ sumPaymentsProjects(items) }}</h3>
                    <v-spacer />
                    <v-btn
                      small
                      :disabled="$store.getters.loadingApp === 1"
                      @click="payProject(items)"
                    >
                      Pay Project
                    </v-btn>
                  </div>
                </th>
              </template>
              <template v-slot:[`item.full_name`]="{ item }">
                <span class="d-flex flex-row">
                  <v-btn
                    x-small
                    rounded
                    class="align-self-center mr-2"
                    @click="goClient(item.client_id, item.id)"
                  >
                    <v-icon
                      color="green"
                      small
                    >$vuetify.icons.icon_mdi_pencil</v-icon>
                  </v-btn><span class="text-wrap">{{ item.full_name }}
                  </span>
                </span>
              </template>

              <template v-slot:[`item.payment`]="{ item }">
                {{ paymentFormatted(item) }}
              </template>

              <template v-slot:[`item.amountPaidReceiver`]="{ item }">
                {{ openAmountFormatted(item) }}
              </template>

              <template v-slot:[`item.start`]="{ item }">
                {{ formattedDate(item.start) }}
              </template>
              <template v-slot:[`item.end`]="{ item }">
                {{ formattedDate(item.end) }}
              </template>
              <template v-slot:[`item.type_id`]="{ item }">
                <span v-if="`${item.type_id}` == 1"><v-icon>$vuetify.icons.icon_volunteer</v-icon> #{{ item.number_type }}</span>
                <span v-if="`${item.type_id}` == 2"><v-icon>$vuetify.icons.icon_internship</v-icon> #{{ item.number_type }}</span>
              </template>
              <template v-slot:[`item.statusResourceId`]="{ item }">
                <v-chip
                  :color="getStatusResource(item.statusResourceId).color"
                  text-color="white"
                  v-html="getStatusResource(item.statusResourceId).name"
                />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDialogEditResource(item.id)"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              v-if="donationsGiftedIncome.length > 0"
              :headers="headersDonationsGifted"
              :items="donationsGiftedIncome"
              class="elevation-1"
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
              sort-by="dateTime"
              dense
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Donations Gifted Income</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.dateTime`]="{ item }">
                {{ formattedDate(item.dateTime) }}
              </template>
              <template v-slot:[`item.amountDollars`]="{ item }">
                {{ amountDollarsFormatted(item) }}
              </template>
            </v-data-table>
            <v-data-table
              v-if="donationsGiftedOutgoings.length > 0"
              :headers="headersDonationsGifted"
              :items="donationsGiftedOutgoings"
              class="elevation-1"
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
              sort-by="dateTime"
              dense
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Donations Gifted Outgoing</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.dateTime`]="{ item }">
                {{ formattedDate(item.dateTime) }}
              </template>
              <template v-slot:[`item.amountDollars`]="{ item }">
                {{ amountDollarsFormatted(item) }}
              </template>
            </v-data-table>
            <v-row justify="center">
              <h3 v-if="hasTotalDonationsGiftedAvailable">
                Available for Donation: ${{ totalDonationsGiftedAvailableFormatted }}
              </h3>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
      <v-tab-item>
        <div class="d-flex flex-row flex-wrap">
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            class="white--text my-7 mx-2"
            @click="$router.push({ name: 'Projects'})"
          >
            Projects
          </v-btn>
        </div>
        <v-data-table
          :headers="headersProjectPlacements"
          :items="updatedProjectPlacements"
          class="elevation-1"
          :items-per-page="-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Project Placements</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              />
              <v-spacer />
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                @click="editedItem.obsolete = null, dialogEditProjectPlacement = true"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
              <v-dialog
                v-model="dialogEditProjectPlacement"
                max-width="500px"
                persistent
              >
                <v-form ref="dialogForm">
                  <v-card>
                    <v-card-title class="ppc_darkgreen darken-1">
                      <span class="headline white--text"> {{ formTitle }} {{ editedItem.project }} - {{ editedItem.organisation }} </span>
                    </v-card-title>
                    <v-card-text>
                      <v-select
                        v-model="editedItem.project_id"
                        :items="selectProjects"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="Select project"
                        single-line
                        prepend-icon="$vuetify.icons.icon_volunteer"
                        validate-on-blur
                        clearable
                        class="mr-2"
                      />
                      <v-select
                        v-model="editedItem.organisation_id"
                        :items="selectOrganisations"
                        item-text="organisation"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="Select Organisation"
                        single-line
                        prepend-icon="$vuetify.icons.icon_mdi_domain"
                        validate-on-blur
                        clearable
                      />
                      <div class="d-flex flex-row flex-wrap">
                        <v-text-field
                          v-model.trim="editedItem.donation"
                          label="donation"
                          prepend-icon="mdi-currency-usd ppc_darkgreen--text"
                          clearable
                          class="mr-4"
                          style="width: 50px"
                        />
                        <v-select
                          v-model="editedItem.donation_type"
                          :items="donation_types"
                          item-text="text"
                          item-value="value"
                          :menu-props="{ auto: true }"
                          label="Select type"
                          single-line
                          validate-on-blur
                          clearable
                          style="width: 150px"
                        />
                      </div>
                      <v-textarea
                        v-model="editedItem.comments"
                        class="rounded-xl ma-3"
                        auto-grow
                        clearable
                        counter="255"
                        outlined
                        label="Comments (255 max)"
                        :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                      />
                      <v-checkbox
                        v-model="editedItem.obsolete"
                        label="Not active"
                        @change="setObsolete($event)"
                      />
                      <v-text-field
                        v-if="editedItem.obsolete !== null"
                        :value="formattedDate(editedItem.obsolete)"
                        disabled
                        label="From"
                        class="ml-2"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="ppc_darkgreen darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="ppc_darkgreen darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>

              <v-dialog
                v-model="dialogDelete"
                max-width="500px"
              >
                <v-card>
                  <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="ppc_darkgreen darken-1"
                      text
                      @click="closeDelete"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="ppc_darkgreen darken-1"
                      text
                      @click="deleteItemConfirm"
                    >
                      OK
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.project }} - {{ item.organisation }}
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            {{ item.contact }}
            <v-btn
              v-if="item.contact" 
              fab 
              color="ppc_pink"
              height="20px"
              width="20px"
              right
              top
              class="ml-3"
              @click="openContactInfo(item)"
            >
              <v-icon color="white">
                $vuetify.icons.icon_mdi_information_variant
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.obsolete`]="{ item }">
            <v-icon
              v-if="item.obsolete !== null"
              small
              color="ppc_pink"
            >
              $vuetify.icons.icon_mdi_cancel
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>


    <v-dialog
      v-model="dialogContactInfo"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="ppc_darkgreen darken-1">
          <span class="headline white--text"> {{ contact.name }} </span>
        </v-card-title>
        <v-card-subtitle
          v-if="contact.organisation"
          class="mt-5"
        >
          <v-icon
            class="mr-2"
          >
            $vuetify.icons.icon_mdi_domain
          </v-icon>
          <span class="font-weight-bold">{{ contact.organisation }}</span>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col
              v-if="contact.address || contact.country"
              cols="12"
            >
              <v-icon
                class="mr-2"
              >
                $vuetify.icons.icon_mdi_map_marker
              </v-icon>
              {{ contact.address }}
              <span v-if="contact.address && contact.country">,</span>
              {{ contact.country }}
            </v-col>
                        
            <v-col
              v-if="contact.phone"
              cols="12"
              sm="6"
            >
              <v-icon
                class="mr-2"
              >
                mdi-cellphone ppc_darkgreen--text
              </v-icon>
              {{ contact.phone }}
            </v-col>
            <v-col
              v-if="contact.phone_alt"
              cols="12"
              sm="6"
            >
              <v-icon
                class="mr-2"
              >
                mdi-phone ppc_darkgreen--text
              </v-icon>
              {{ contact.phone_alt }}
            </v-col>
            <v-col
              v-if="contact.email"
              cols="12"
              sm="6"
            >   
              <v-icon
                class="mr-2"
              >
                mdi-email ppc_darkgreen--text
              </v-icon>
              {{ contact.email }}
            </v-col>
            <v-col
              v-if="contact.comments"
              cols="12"
            >   
              <v-icon
                class="mr-2"
              >
                mdi-message-text ppc_darkgreen--text
              </v-icon>
              {{ contact.comments }}
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogContactInfo = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogFichaDeProyecto"
      max-width="80vw"
      class="scroll-y"
    >
      <v-card
        v-if="$store.getters.loadingApp !== 1"
        flat
        class="d-flex justify-space-around"
      >
        <v-card 
          flat
          class="pa-4"
          width="210mm"
        >
          <span
            id="areatoprint"
            class="ma-2"
            v-html="messageHTML"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialogFichaDeProyecto = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="printDialogContent()"
            >
              Print/Download
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>

import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import compare from '../mixins/compare';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days';
dayjs.extend(dayjsBusinessDays);
import decUtil from '@/utils/decimalUtils';

export default {

    mixins: [inputRules, formattedDate, compare],
    data: () => ({
        itemsTab: [
            'Ongoing', 'Donations', 'Projects & Placements'
        ],
        activeTabPlacements: 0,
        itemsDonationsTab: [
            'Debit', 'Gifts'
        ],
        activeTabDonations: 0,
        decUtil,
        donationsToBePaid: decUtil.toDec(0),
      dialogEditProjectPlacement: false,
      dialogDelete: false,
      dialogContactInfo: false,
      dialogEditResource: false,
      headersProjectPlacements: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        { text: 'Category', value: 'category' },
        { text: 'Type', value: 'type' },
        { text: 'Contact', value: 'contact' },
        { text: 'Donation USD', value: 'donation' },
        { text: 'Type', value: 'donation_type' },
        { text: 'Comments', value: 'comments' },
        { text: 'Obsolete', value: 'obsolete' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      donation_types: [
        { text: 'once' , value: 'once'},
        { text: 'every week' , value: 'every week'},
        { text: 'every month' , value: 'every month'},
      ],
      headersResourcesScope: [
          { text: 'Client', value: 'full_name', groupable: false },
          { text: 'Agency', value: 'agency' },
          { text: 'Project', value: 'projectName' },
          { text: 'Placement', value: 'organisationName' },
          { text: 'Time', value: 'projectMorningAfternoon' },
          { text: 'Accommodation(s)', value: 'accPlacements' },
          { text: 'Type', value: 'type_id', groupable: false },
          { text: 'Start', value: 'start', groupable: false },
          { text: 'End', value: 'end', groupable: false },
          { text: 'Comments', value: 'comments', groupable: false },
          { text: 'Status', value: 'statusResourceId', groupable: false },
          { text: 'Open', value: 'actions', sortable: false, groupable: false },
        ],
      headersResourcesDonations: [
          { text: 'Client', value: 'full_name', groupable: false },
          { text: 'Agency', value: 'agency' },
          { text: 'Donation', value: 'payment' },
          { text: 'Open', value: 'amountPaidReceiver' },
          { text: 'Service Name', value: 'servicesName', groupable: false },
          { text: 'Type/Nr', value: 'type_id', groupable: false },
          { text: 'Placement', value: 'organisationName' },
          { text: 'Start', value: 'start', groupable: false },
          { text: 'End', value: 'end', groupable: false },
          { text: 'Status', value: 'statusResourceId', groupable: false },
          { text: 'Actions', value: 'actions', sortable: false, groupable: false },
      ],
      headersDonationsGifted: [
            {
                text: 'Date',
                align: 'start',
                sortable: false,
                value: 'dateTime',
            },
            { text: 'Donation', value: 'amountDollars' },
            { text: 'Contact', value: 'contactName' },
            { text: 'Methods', value: 'paymentMethodName' },
            { text: 'Comments', value: 'comments' },
        ],
      updatedProjectPlacements: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        contact: '',
        category: '',
        donation: '',
        donation_type: '',
        comments: '',
        obsolete: false,
      },
      defaultItem: {
        name: '',
        contact: '',
        category: '',
        donation: '',
        donation_type: '',
        comments: '',
        obsolete: false,
      },
      contact: [],
      resources: [],
    //   resourcesPlaced: [],
    //   resourcesNotPlaced: [],
      resourcesToBePaid: [],
      resource: [],
      donationsGiftedIncome: [],
      donationsGiftedOutgoings: [],
      totalDonationsGiftedAvailable: 0,
      loadingButtonDonationsGifted: false,
      loadingButtonPaidDonations: false,
      loadingButtonAllProjectPlacements: false,
      selectOrganisations: [],
      scopeResourcesPlanned: 'ongoing',
      resourcesScope: [],
      searchResourcesScope: '',
      selectedReservation: [],
      selectedReservationSingleSelect: true,
      dialogFichaDeProyecto: false,
      messageHTML: '',
    }),

    computed: {

        formTitle () {
            return this.editedIndex === -1 ? 'New Placement ' : ''
        },

        selectProjects () {
            let projects = JSON.parse(JSON.stringify(this.$store.state.projects.filter(function(select_item) {
                return select_item.obsolete === null;
            })));
            return projects.sort(this.dynamicSort('name'));
        },

        getPlacementComments () {
            if (this.resource.placement_id) {
                let placementId = this.resource.placement_id;
                var placement = this.$store.state.projectPlacements.filter(function(select_item) {
                    return select_item.id === placementId;
                })[0];
                return placement.comments;
            } else {
                return '';
            }
        },

        itemsPerPage () {
            return this.$store.getters.itemsPerPage
        },

        donationsToBePaidDec() {
            return this.donationsToBePaid;
        },

        hasDonationsToBePaid() {
            return !this.donationsToBePaid.isZero();
        },

        donationsToBePaidFormatted() {
            return this.decUtil.format(this.donationsToBePaid);
        },

        totalDonationsGiftedAvailableDec() {
            return this.decUtil.toDec(this.totalDonationsGiftedAvailable || 0);
        },

        hasTotalDonationsGiftedAvailable() {
            return !this.totalDonationsGiftedAvailableDec.isZero();
        },

        totalDonationsGiftedAvailableFormatted() {
            return this.decUtil.format(this.totalDonationsGiftedAvailableDec);
        },

        calcDonationProject() {
            if (!this.resource?.placement_id) {
                return this.decUtil.toDec(0);
            }

            const placement = this.$store.state.projectPlacements.find(
                p => p.id === this.resource.placement_id
            );

            if (!placement) {
                return this.decUtil.toDec(0);
            }

            const donation = this.decUtil.toDec(placement.donation || 0);
            const duration = this.decUtil.toDec(this.resource.duration || 0);

            switch (placement.donation_type) {
                case 'once':
                    return donation;

                case 'every week':
                    return donation.times(duration);

                case 'every month':
                    return donation.times(
                        Math.ceil(this.resource.duration / 4)
                    );

                default:
                    return this.decUtil.toDec(0);
            }
        },

        getDonationType() {
            if (!this.resource?.placement_id) {
                return this.decUtil.toDec(0);
            }

            const placement = this.$store.state.projectPlacements.find(
                p => p.id === this.resource.placement_id
            );

            if (!placement) {
                return "not known";
            }

            return placement.donation_type;
        },

        getDonationProject() {
            if (!this.resource?.placement_id) {
                return this.decUtil.toDec(0);
            }

            const placement = this.$store.state.projectPlacements.find(
                p => p.id === this.resource.placement_id
            );

            if (!placement) {
                return this.decUtil.toDec(0);
            }

            return this.decUtil.toDec(placement.donation || 0);
        },
        
    },

    watch: {
    },

    beforeCreate () {
        if (this.$store.state.accessProjects === 0) {
            this.$router.push({ name: 'Illegal' })
        }
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
        dayjs.locale("en");
        this.initialize();
    },

    methods: {
        async initialize () {
            const start = Date.now();
            console.log('***1');

            this.$store.dispatch('setLoadingApp', 1);

            try {
                // -----------------------------
                // Parallel data loading
                // -----------------------------
                const [, , , donationsRaw] = await Promise.all([
                    this.getResources(),
                    this.$store.dispatch('getProjects'),
                    this.$store.dispatch('getProjectPlacements'),
                    this.$store.dispatch('getDonationsToBePaid')
                ]);

                const organisationsRaw = this.$store.state.organisations;

                // -----------------------------
                // Canonical money handling
                // -----------------------------
                this.donationsToBePaid = this.decUtil.toDec(donationsRaw || 0);

                // -----------------------------
                // Organisations normalization
                // -----------------------------
                const organisations = organisationsRaw.map(o => ({
                ...o,
                organisation: o.name
                }));

                this.selectOrganisations = organisations.sort(this.dynamicSort('name'));

                // -----------------------------
                // Placements (local copy)
                // -----------------------------
                this.updatedProjectPlacements = JSON.parse(
                JSON.stringify(this.$store.state.projectPlacements)
                );

                // -----------------------------
                // Route-dependent behavior
                // -----------------------------
                if (this.$route.params.resourceId) {
                this.openDialogEditResource(this.$route.params.resourceId);
                // this.$store.dispatch('saveDataForReport', ???); // left as-is
                } else {
                this.$store.dispatch('setLoadingApp', 'dis');
                }

                // -----------------------------
                // Donations gifted
                // -----------------------------
                this.getDonationsGifted();

                // -----------------------------
                // Breadcrumbs
                // -----------------------------
                const previousView =
                this.$store.state.breadcrumbs[
                    this.$store.state.breadcrumbs.length - 1
                ];

                if (previousView === 'Projects') {
                this.activeTabPlacements = 2;
                }

                this.$store.dispatch('breadcrumbs', ['ProjectPlacements']);

            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }

            const end = Date.now();
            console.log('***2', (end - start) / 1000);
        },

        paymentFormatted(item) {
            if (!item || item.payment == null) return '';
            return item.currency + this.decUtil.format(item.payment);
        },

        openAmountFormatted(item) {
            if (
                !item ||
                item.payment == null ||
                item.amountPaidReceiver == null
            ) {
                return '';
            }

            const open = this.decUtil
            .toDec(item.payment)
            .minus(item.amountPaidReceiver);

            return item.currency + this.decUtil.format(open);
        },

        amountDollarsFormatted(item) {
            if (!item || item.amountDollars == null) return '';
            return '$' + this.decUtil.format(item.amountDollars);
        },

      async getResources() {
        this.$store.dispatch('setLoadingApp', 'add');
        if (this.scopeResourcesPlanned === 'completed') {
            // this.resources = await this.$store.dispatch('getResourcesCompletedProjects');
            await Promise.all([this.resources = await this.$store.dispatch('getResourcesCompletedProjects')]);
        } else {
            // this.resources = await this.$store.dispatch('getResourcesAllProjects');
            await Promise.all([this.resources = await this.$store.dispatch('getResourcesAllProjects')]);
        }

        this.resources = this.prepareResourcesFromDB(this.resources);

        this.resourcesToBePaid = this.resources.filter(function(select_item) {
            return select_item.statusResourceId !== 9 && select_item.statusResourceId !== 8 && select_item.statusResourceId !== 15 && select_item.placement_id !== null && select_item.payment - select_item.amountPaidReceiver !== 0;
        })

        this.resourcesToBePaid.sort(this.dynamicSort('organisationName'));
        
        if (this.dialogEditResource) {
            // console.log('initialize test1')
            let itemId = this.resource.id
            let resource = this.resources.filter(function(select_item) {
                return select_item.id === itemId;
            })
            if (resource.length === 0) {
                this.dialogEditResource = false;
                this.resource = [];
            } else {
                this.resource = resource[0]
            }
        }
        this.filterResources();
        this.loadingButtonAllProjectPlacements = false;
        this.$store.dispatch('setLoadingApp', 'dis');
      },

      prepareResourcesFromDB(resources) {
          
        for (let i = 0; i < resources.length; i++) {

            (resources[i].start) ? resources[i].start = this.formattedDate(resources[i].start, 'date') : resources[i].start = null;
            (resources[i].end) ? resources[i].end = this.formattedDate(resources[i].end, 'date') : resources[i].end = null;
            (resources[i].info_to_client) ? resources[i].info_to_client = this.formattedDate(resources[i].info_to_client, 'date') : resources[i].info_to_client = null;
            (resources[i].info_to_provider) ? resources[i].info_to_provider = this.formattedDate(resources[i].info_to_provider, 'date') : resources[i].info_to_provider = null;
            (resources[i].reserved) ? resources[i].reserved = this.formattedDate(resources[i].reserved, 'date') : resources[i].reserved = null;
            if (resources[i].statusResourceId === 9 || resources[i].placement_id === null) {
                resources[i].isSelectable = false;
            }

            this.resources[i].payment = this.decUtil.format(this.resources[i].payment);

            // get project name
            let projectId = resources[i].project_id;
            let projectName = this.$store.state.projects.filter(function(select_item) {
                return select_item.id === projectId;
            });
            if (projectName.length > 0) {
                resources[i].projectName = projectName[0].name;
            }

        }

        resources = resources.map(r => ({
            ...r,
            duration: Math.ceil(
                (dayjs(r.end).businessDiff(dayjs(r.start)) + 1) / 5
            ),
        }));

        return resources;

      },

      filterResources() {
        if (this.scopeResourcesPlanned === 'completed') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 1 || select_item.statusResourceId === 15;
            });
        } else if (this.scopeResourcesPlanned === 'notPlaced') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return (select_item.placement_id === null || select_item.reserved === null) && (select_item.statusResourceId === 5 || select_item.statusResourceId === 6 || select_item.statusResourceId === 7 || select_item.statusResourceId === 9);
            });
        } else if (this.scopeResourcesPlanned === 'placed') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.placement_id !== null && select_item.reserved !== null && select_item.statusResourceId !== 6 && select_item.statusResourceId !== 7 && select_item.statusResourceId !== 9;
            });
        } else if (this.scopeResourcesPlanned === 'ongoing') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId !== 15 && select_item.statusResourceId !== 1;
            });
        } else if (this.scopeResourcesPlanned === 'notConfirmed') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 8;
            });
        } else {
            // scopeResourcesPlanned is 'all'
            this.resourcesScope = this.resources;
        }
      },

      openContactInfo(editedItem) {
        let tmp = editedItem.contact_id;
        this.contact = this.$store.state.contacts.filter(function(select_item) {
            return select_item.id === tmp;
        })[0];
        this.dialogContactInfo = true;
      },

      editItem (item) {
        this.editedIndex = this.updatedProjectPlacements.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialogEditProjectPlacement = true;
      },

      deleteItem (item) {
        this.editedIndex = this.updatedProjectPlacements.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialogDelete = true;
      },

      async deleteItemConfirm () {
        let response = await await this.$store.dispatch('deleteProjectPlacement', this.editedItem.id)
        if (response.data.affectedRows === 1) {
            this.$store.dispatch('successMessage', 'Project placement deleted');
        } else {
            this.$store.dispatch('errorMessage', 'Something went wrong');
        }
        await this.$store.dispatch('getProjectPlacements');
        this.updatedProjectPlacements = JSON.parse(JSON.stringify(this.$store.state.projectPlacements));
        this.closeDelete()
      },

      close () {
        this.dialogEditProjectPlacement = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async openDialogEditResource(id) {
        this.$store.dispatch('setLoadingApp', 'add');
        // console.log('openDialogEditResource 1', id);
        let result = this.resources.filter(function(select_item) {
            return select_item.id === id;
        });
        // console.log('openDialogEditResource 2', result);
        if (result.length === 0) {
            result = await this.$store.dispatch('getResourceId', id);
            // console.log('openDialogEditResource 3', result);
        } else {
            result = result[0];
        }
        this.resource = Object.assign({}, result);
        this.resource.payment = this.decUtil.format(this.resource.payment);
        // console.log('openDialogEditResource 4', this.resource);
        this.dialogEditResource = true;
        this.$store.dispatch('setLoadingApp', 0);
      },

      getStatusResource(id) {
            if (id) {
                return this.$store.state.statusResources.filter((select_item) => {
                    return select_item.id === id;
                })[0];
            } else {
                return [];
            }
        },

        categoriesProjects (resourceType) {
            let type;
            if (resourceType === 1) {
                type = "Volunteering"
            } else {
                type = "Internship"
            }
            let selection = this.$store.state.projects.filter(function(select_item) {
                return select_item.type === type;
            })
            return selection.sort(this.dynamicSort('category'));
        },

        filterProjects (resourceType, categoryId, projectId) {
            let type;
            var selection;
            if (resourceType === 1) {
                type = "Volunteering"
            } else {
                type = "Internship"
            }
            if (projectId) {
                selection = this.$store.state.projects.filter(function(select_item) {
                    return select_item.id === projectId && select_item.type && select_item.obsolete === null;
                })
            } else {
                if (categoryId) {
                    selection = this.$store.state.projects.filter(function(select_item) {
                        return select_item.category_id === categoryId && select_item.type === type && select_item.obsolete === null;
                    })
                } else {
                    selection = this.$store.state.projects.filter(function(select_item) {
                        return select_item.type === type && select_item.obsolete === null;
                    })
                }
            }
            return selection.sort(this.dynamicSort('name'));
        },

        filterPlacements (resourceType, categoryId, projectId) {
            let type;
            var selection;
            if (resourceType === 1) {
                type = "Volunteering"
            } else {
                type = "Internship"
            }
            if (projectId) {
                selection = this.$store.state.projectPlacements.filter(function(select_item) {
                    return select_item.project_id === projectId && select_item.obsolete === null;
                })
            } else {
                if (categoryId) {
                    selection = this.$store.state.projectPlacements.filter(function(select_item) {
                        return select_item.category_id === categoryId && select_item.type === type && select_item.obsolete === null;
                    })
                } else {
                    selection = this.$store.state.projectPlacements.filter(function(select_item) {
                        return select_item.type === type && select_item.obsolete === null;
                    })
                }
            }
            return selection.sort(this.dynamicSort('name'));
        },

        changePayment() {
            if (!this.resource.payment) {
                // console.log('changePayment test1',this.resource.payment)
                this.resource.payment = this.decUtil.format(this.calcDonationProject);
            }
            this.resource.payment = this.decUtil.format(this.resource.payment);
        },

        async insertUpdateResource () {
            this.resource.updating = true;
            this.resource.currency = '$';
            (this.resource.start) ? this.resource.start = this.formattedDate(this.resource.start, 'date') : this.resource.start = null;
            (this.resource.end) ? this.resource.end = this.formattedDate(this.resource.end, 'date') : this.resource.end = null;
            (this.resource.info_to_provider) ? this.resource.info_to_provider = this.formattedDate(this.resource.info_to_provider, 'date') : this.resource.info_to_provider = null;
            (this.resource.info_to_client) ? this.resource.info_to_client = this.formattedDate(this.resource.info_to_client, 'date') : this.resource.info_to_client = null;
            (this.resource.reserved) ? this.resource.reserved = this.formattedDate(this.resource.reserved, 'date') : this.resource.reserved = null;
            let payload = {
                client: null,
                applications: null,
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: [],
            };
            // console.log('insertUpdateResource BEFORE', this.resource);
            payload.resources.push(this.resource);
            let results = await this.$store.dispatch('insertUpdateMainItems', payload);
            // console.log('insertUpdateResource results', results);
            if (results) {
                results = results.data.resources;
                const resourcesAdjusted = this.prepareResourcesFromDB(results);
                // console.log('insertUpdateResource ######### 8',resourcesAdjusted);
                let posResults = resourcesAdjusted.findIndex(obj => obj.id == this.resource.id);
                this.resource = resourcesAdjusted[posResults];
                // console.log('insertUpdateResource ######### 9', this.updatedResource, results[posResults], posResults);
            }

            let objIndex = null;
            objIndex = this.resources.findIndex(obj => obj.id == this.resource.id);
            this.resources.splice(objIndex, 1, this.resource);
            objIndex = this.resourcesScope.findIndex(obj => obj.id == this.resource.id);
            this.resourcesScope.splice(objIndex, 1, this.resource);
            objIndex = this.resourcesToBePaid.findIndex(obj => obj.id == this.resource.id);
            this.resourcesToBePaid.splice(objIndex, 1, this.resource);
            
            // await this.getResources();
            this.resource.updating = false;
            this.$store.dispatch('setLoadingApp', 0);
        },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

        async save () {
          if(this.$refs.dialogForm.validate()){
            let tmpName = this.editedItem.name.trim();
            let tmpId = this.editedItem.placement_id;
            let doubleName = this.updatedProjectPlacements.filter(function(select_item) {
                return select_item.name === tmpName && select_item.placement_id === tmpId;
            })
            if (doubleName.length > 0 && this.editedIndex !== this.updatedProjectPlacements.indexOf(doubleName[0])) {
                this.$store.dispatch('errorMessage', 'The placement "' + this.editedItem.name + '" already exists!');
                return;
            } else {
                await this.$store.dispatch('insertProjectPlacement', this.editedItem)
                await this.$store.dispatch('getProjectPlacements');
                this.updatedProjectPlacements = JSON.parse(JSON.stringify(this.$store.state.projectPlacements));
            }
            this.close();
          }
        },

      goClient(id, resourceId) {
            this.$store.dispatch('setLoadingApp', 1);
            this.$router.push({ name: 'Client', params: { id: id, resourceId: resourceId } })
        },

        setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
            
        },

        sumPaymentsProjects(items) {
            if (!Array.isArray(items) || items.length === 0) {
                return this.decUtil.toDec(0);
            }

            return items.reduce((sum, item) => {
                const payment = this.decUtil.toDec(item.payment || 0);
                const paid = this.decUtil.toDec(item.amountPaidReceiver || 0);
                return sum.plus(payment.minus(paid));
            }, this.decUtil.toDec(0));
        },

        payProject(resources) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { paymentProject: this.sumPaymentsProjects(resources), resources: resources } })
        },

        async getDonationsGifted() {
            this.loadingButtonDonationsGifted = true;

            try {
                // -----------------------------
                // Income
                // -----------------------------
                this.donationsGiftedIncome =
                await this.$store.dispatch('getDonationsGiftedIncome');

                const paymentMethods = this.$store.state.paymentMethods;

                const totalDonationsGiftedIncomeDec =
                this.donationsGiftedIncome.reduce((sum, item) => {
                    // contact label
                    item.contactName = item.client_id
                    ? `${item.clientName} (client)`
                    : `${item.contactName} (contact)`;

                    // payment method name
                    const pm = paymentMethods.find(p => p.id === item.paymentMethod);
                    if (pm) {
                    item.paymentMethodName = pm.method;
                    }

                    // sum amount (USD)
                    return sum.plus(
                    this.decUtil.toDec(item.amountDolares || 0)
                    );
                }, this.decUtil.toDec(0));

                // -----------------------------
                // Outgoings
                // -----------------------------
                this.donationsGiftedOutgoings =
                await this.$store.dispatch('getDonationsGiftedOutgoings');

                const totalDonationsGiftedOutgoingsDec =
                this.donationsGiftedOutgoings.reduce((sum, item) => {
                    return sum.plus(
                    this.decUtil.toDec(item.amountDolares || 0)
                    );
                }, this.decUtil.toDec(0));

                // -----------------------------
                // Available
                // -----------------------------
                this.totalDonationsGiftedAvailable =
                totalDonationsGiftedIncomeDec.minus(
                    totalDonationsGiftedOutgoingsDec
                );

            } finally {
                this.loadingButtonDonationsGifted = false;
            }
        },

        async calcDatesResource(action) {
            if ((action === 'duration' && this.resource.start) || ((action === 'start' && this.resource.duration))) {
                this.resource.end = this.addbusinessWeeks(this.resource.start, ((this.resource.duration * 5)-1));
            }
            if (action === 'start' || action === 'end') {
                if (this.resource.start && this.resource.end) {
                    let weeks = ((dayjs(this.resource.end).businessDiff(dayjs(this.resource.start))+1)/5);

                    console.log('weeks', weeks);

                    if (weeks < this.resource.min_duration) {
                      this.resource.end = this.addbusinessWeeks(this.resource.start, ((this.resource.duration * 5)-1));
                    } else {
                      this.resource.duration = Math.ceil(weeks);
                    }
                }
            }
            // this.insertUpdateResource();
        },

        addbusinessWeeks(startDate, days) {
            let new_date = dayjs(startDate).businessDaysAdd(days, 'd');
            let day = new_date.format('DD');
            let month = new_date.format('MM');
            let year = new_date.format('YYYY');
            return year + '-' + month + '-' + day
        },

        openTransactionOutgoings(transIdOutgoings) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { transIdOutgoings: transIdOutgoings } })
        },
            
        async goCartaDePresentacion (resources) {

            console.log('goCartaDePresentacion', resources);

            let load = {};
            let payload = [];
            
            this.$store.dispatch('setLoadingApp', 1);

            for (let i = 0; i < resources.length; i++) {
                if (!resources[i].info_to_provider) {
                    let n = new Date();
                    resources[i].info_to_provider = this.formattedDate(n,'date');
                    resources[i].reserved = null;
                    resources[i].info_to_client = null;
                    this.resource = resources[i];
                    this.insertUpdateResource();
                }
                let client = JSON.parse(JSON.stringify(await this.$store.dispatch('getClientId', resources[i].client_id)));
                load = {
                    client: client,
                    resource: resources[i],
                }
                payload.push(load);
            }

            let messageHeader = "<div style='margin-top: 0cm; margin-bottom: 0cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif;'>" +
                "<div style='display: flex; flex-direction: row; justify-content: space-between; margin: 0 0 0cm 0;'>" +
                    "<div style='font-family: Roboto, sans-serif; font-size: 32px; color: #35b729;'><span>PROYECTO</span><strong>PERU</strong></div>" +
                    "<div style='font-size: 32px; color: grey; display: flex; flex-direction: column; align-items: flex-end;'>" + 
                        "<div style='font-size: 24px;'>Carta de Presentación</div>" +
                        "<div style='font-size: 14px;'><i>¡Brindando nuevas oportunidades para vivir</i></div>" + 
                        "<div style='font-size: 14px;'><i>experiencias culturales inolvidables a</i></div>" + 
                        "<div style='font-size: 14px;'><i>través de voluntariados y pasantías!</i></div>" + 
                        "<div style='font-size: 18px;'>Cusco, " + 
                            dayjs(Date.now()).format('ddd DD MMM YY') +
                        "</div>" + 
                    "</div>" + 
                "</div>" + 
            "</div>"
            let messageBody = "<div style='font-family: Roboto;'>Para: " + payload[0].resource.organisationName + "</div><br>" +
            "<div>Es grato dirigirnos a Ustedes para informarles de la próxima llegada del voluntario de nuestro proyecto a quien ustedes gentilmente acogerán en su Centro: </div>\n\n"
            for (let i = 0; i < payload.length; i++) {

                messageBody += "<div style='font-size: 24px; display: flex; justify-content: space-around; margin: 0.5cm 0 0.3cm 0;'>" + payload[i].client.full_name + "</div>"

                const nationality = this.getNationalityName(payload[i].client.nationality_id);

                if (nationality) {
                    messageBody += "<div><strong>Nacionalidad: </strong>" + nationality + "</div>"
                }

                if (payload[i].client.birthdate) {
                    messageBody += "<div><strong>Edad: </strong>" + dayjs().diff(payload[i].client.birthdate, 'year') + "</div>"
                }

                if (payload[i].client.gender === 'Male') {
                    messageBody += "<div><strong>Género: </strong>Masculino</div>"
                } else if (payload[i].client.gender === 'Female') {
                    messageBody += "<div><strong>Género: </strong>Femenino</div>"
                } else {
                    messageBody += "<div><strong>Género: </strong>No conocido</div>"
                }
                
                messageBody += "<div><strong>Período de Pasantía Del: </strong>" + dayjs(payload[i].resource.start).format('ddd DD MMM YY') + " <strong>Hasta: </strong>" + dayjs(payload[i].resource.end).format('ddd DD MMM YY') + "</div>"
                if (payload[i].client.occupation) {
                    messageBody += "<div><strong>Ocupación / Profesión: </strong>" + payload[i].client.occupation + "</div>"
                }

                if (payload[i].resource.projectMorningAfternoon) {
                    if (payload[i].resource.projectMorningAfternoon === 'mornings') {
                        messageBody += "<div><strong>Shift: </strong>Mañana</div>"
                    } else if (payload[i].resource.projectMorningAfternoon === 'afternoons') {
                        messageBody += "<div><strong>Shift: </strong>Tarde</div>"
                    } else {
                        messageBody += "<div><strong>Shift: </strong>No conocido</div>"
                    }
                }
                
            }
            messageBody += "<br><div>Como es de su conocimiento, PROYECTO PERU es una institución que desarrolla sus actividades en beneficio de los proyectos con los cuales trabaja; a través de voluntarios en actividades educativas y asistencia social.</div>"
            messageBody += "<br><div>Durante la permanencia del voluntario usted podrá coordinar en cualquier momento con Proyecto Peru a los teléfonos 950 301 317 o a nuestra oficina ubicada en Arcopata 466 -  Cusco.</div>"
            messageBody += "<br><div>Finalmente le agradeceremos contactarse inmediatamente en caso de suscitarse algún inconveniente relacionado a la salud o comportamiento del voluntario.</div>"
            messageBody += "<br><div>Agradeciendo nuevamente su gentileza en trabajar con los voluntarios.</div>"
            messageBody += "<br><div>Atentamente, </div>"
            messageBody += "<br><div>PROYECTO PERU</div>"
            let messageFooter = "<div style='margin-top: 1cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif; background-color: #c7d3d1; height: 2px;'></div>"
            messageFooter += "<div style='display: flex; justify-content: space-around; font-size: 14px;'>Proyecto Peru Centre, Arcopata 466 Cusco, Peru</div>"
            messageFooter += "<div style='display: flex; justify-content: space-around; font-size: 14px;' class='mb-0 pb-0'>Tel. +51 (084) 240 278 / 950 301 317 Email: office@proyectoperucentre.org</div>"
            this.messageHTML = messageHeader + messageBody + messageFooter;

            this.dialogFichaDeProyecto = true;
            
            this.$store.dispatch('setLoadingApp', 0);
            
        },

        getNationalityName (nationalityId) {
          if (nationalityId === null) return null;
          const nationality = this.$store.state.itemsNationality.filter(c => c.id === nationalityId)[0];
          return nationality ? nationality.country_name_es : null;
        },

        async confirmReservations (resources) {
            this.$store.dispatch('progressAdvance', 0);
            this.$store.dispatch('showProgressBar', true);
            let progress = 1;
            let step = (100 - progress)/(
                resources.length
            );
            for (let i = 0; i < resources.length; i++) {
                // await this.$store.dispatch('getClientId', resources[i].client_id);
                if (!resources[i].reserved) {
                    let n = new Date();
                    if (!resources[i].info_to_provider) {
                        resources[i].info_to_provider = this.formattedDate(n,'date');
                    }
                    resources[i].reserved = this.formattedDate(n,'date');
                    this.resource = resources[i];
                    this.insertUpdateResource();
                }
                progress = progress + step;
                this.$store.dispatch('progressAdvance', progress);
            }
            this.$store.dispatch('showProgressBar', false);
            this.$store.dispatch('progressAdvance', 100);
        },

        selectResourceReservation() {
        if (this.selectedReservation.length === 0) {
            this.filterResources();
            this.selectedReservationSingleSelect = true;
            return;
        } else {
                let placement_id = this.selectedReservation[0].placement_id;
                this.selectedReservationSingleSelect = false;
                this.resourcesScope = this.resourcesScope.filter(function(select_item) {
                    return select_item.placement_id === placement_id;
                });
            }
        },

        checkResourceDates() {
            if (this.resource.info_to_provider === null) {
                this.resource.info_to_provider = this.resource.info_to_client;
            }
            if (this.resource.reserved === null) {
                this.resource.reserved = this.resource.info_to_client;
            }
        },

        printDialogContent() {
            // 1. Select the v-dialog's content
            const dialogContent = document.querySelector('#areatoprint'); // Assuming your dialog content is within a v-card

            // 2. Create a new window for printing
            const printWindow = window.open('', '', 'width=600,height=500');

            // 3. Write the dialog content to the new window
            printWindow.document.write(dialogContent.outerHTML);

            // 4. Close the new window after printing (optional)
            // printWindow.addEventListener('beforeprint', () => {
            //   printWindow.close();
            // });

            // 5. Trigger the print dialog
            printWindow.document.close(); // Important to close the document
            printWindow.print();
            printWindow.close();
            this.dialogFichaDeAlojamiento = false;
        },

    },
  }

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
</style>